export default function compareDates (lastActivityDate) {
    let created = Date.now(),
        updated = new Date(lastActivityDate)
    return Math.floor((created - updated) / (1000*60*60*24))
}